export default "__VITE_ASSET__a348bcea__"